import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Store, Select, Actions, ofActionSuccessful } from '@ngxs/store';
import { merge, Observable, of, Subject } from 'rxjs';
import { mapTo, takeUntil } from 'rxjs/operators';
import { AuthState } from '../core/auth/auth.state';
import { StateMessage } from '../core/state.types';
import { Router } from '@angular/router';
import { ForgotPasswordRouterState } from './forgot-password.models';
import { isDefined, shareReplayRefCount } from '@oneapp/main/core/utils/oa.utils';
import { ForgotPassword } from '@oneapp/core/auth/auth.actions';

@Component({
    selector: 'oa-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
    @Select(AuthState.isChangingPassword) public isChangingPassword$: Observable<boolean>;
    @Select(AuthState.authStatusMessage) public authStatusMessage$: Observable<StateMessage>;

    public emailFormControl = new UntypedFormControl('', [Validators.required, Validators.email]);
    public forgotPasswordForm = new UntypedFormGroup({
        email: this.emailFormControl
    });

    public tokenExpiredError$: Observable<ForgotPasswordRouterState | undefined>;

    private _destroy$: Subject<boolean> = new Subject();

    constructor(
        private _store: Store,
        private _router: Router,
        private _actions: Actions
    ) {
        this.tokenExpiredError$ = merge(
            of(this._router.getCurrentNavigation()?.extras?.state as ForgotPasswordRouterState),
            this._actions.pipe(ofActionSuccessful(ForgotPassword), mapTo(undefined))
        ).pipe(
            shareReplayRefCount()
        );
    }

    public ngOnInit() {
        this.tokenExpiredError$.pipe(
            isDefined(),
            takeUntil(this._destroy$)
        ).subscribe(error =>{
            this.emailFormControl.setValue(error.email);
            this.forgotPasswordForm.updateValueAndValidity();
        });
    }

    public ngOnDestroy() {
        this._destroy$.next(true);
        this._destroy$.complete();
    }

    public onSubmit() {
        this._store.dispatch(new ForgotPassword(this.forgotPasswordForm.value));
    }
}
